/**
 * upload.js - 文件上传接口封装
 * 对应后端: /manage/file/**
 */
import request from '@/utils/request'

/**
 * 通用单图上传
 * @param {File} file - el-upload 自动注入的 file 对象
 */
export function uploadImage(file) {
    const formData = new FormData()
    formData.append('imgUrlFile', file)
    // 如果后端需要 bizType，可以加
    // formData.append('bizType', 'banner')

    return request({
        url: '/manage/banner/uploadPic',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 批量上传（可选）
 */
export function uploadImages(files, bizType) {
    const formData = new FormData()
    files.forEach(file => {
        formData.append('imgUrlFiles', file)
    })
    // bizType 仅需 append 一次
    if (bizType) {
        formData.append('bizType', bizType)
    }
    return request({
        url: '/manage/merchant/uploadImages',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}